import { render, staticRenderFns } from "./PopularCoursePanel.vue?vue&type=template&id=09858c0c&scoped=true"
import script from "./PopularCoursePanel.vue?vue&type=script&lang=js"
export * from "./PopularCoursePanel.vue?vue&type=script&lang=js"
import style0 from "./PopularCoursePanel.vue?vue&type=style&index=0&id=09858c0c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09858c0c",
  null
  
)

export default component.exports